import { Dispatch, ReactNode, SetStateAction } from 'react';

export interface ModalView {
    children: ReactNode;
    isOpen: boolean;
    onClose: Dispatch<SetStateAction<boolean>>;
    maxWidth?: number | string;
    vAlign?: VerticalAlignEnum;
    hAlign?: HorizontalAlignEnum;
    // Modal Option to close it with keyboard (escape)
    isDismissable?: boolean;
}

export enum VerticalAlignEnum {
    TOP = 'flex-start',
    CENTER = 'center',
    BOTTOM = 'flex-end',
}

export enum HorizontalAlignEnum {
    LEFT = 'flex-start',
    CENTER = 'center',
    RIGHT = 'flex-end',
}
